export class ResConsultaExcel {
    public anio: String;
    public trimestre: String;
    public tipo_de_credito: String;
    public departamento: String;
    public municipio: String;
    public solucion_vivienda: String;
    public tenedor: String;
    public moneda: String;
    public rango_vivienda: String;
    public mora: String;
    public numero_creditos: String;
    public saldo_capital_total: String;
    public capital_una_mas_cuotas_vencidad: String;
    public tasa: String;
    public cod_no_mov: String;
    public just_no_mov: String;
  }